import { Alert } from '@mui/material'
import { HoldReaction } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { FC } from 'react'

interface Props {
  reaction: HoldReaction | null
  holdNames: string[]
}

export const HoldEnforcementAlert: FC<Props> = ({ reaction, holdNames }) => {
  const { t } = useTranslate()

  if (!reaction) return null

  const names = holdNames.join(', ')

  if (reaction === HoldReaction.Warning) {
    return (
      <Alert severity='warning' sx={{ mt: 1 }}>
        {t(
          'holdWarningMessage',
          'This container has active holds: {names}. You are allowed to proceed.',
          { names },
        )}
      </Alert>
    )
  }

  return (
    <Alert severity='warning' sx={{ mt: 1 }}>
      {t('holdBlockMessage', 'This container has active holds: {names}. You cannot proceed.', {
        names,
      })}
    </Alert>
  )
}
